import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';
import { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

const columns = [
  {
    label: 'Job ID',
    field: 'jobId',
    sort: 'asc'
  },
  {
    label: 'Job Name',
    field: 'jobName',
    sort: 'asc'
  },
  {
    label: 'Process',
    field: 'process',
    sort: 'asc'
  },
  {
    label: 'Status',
    field: 'status',
    sort: 'asc'
  }
];

class DIJobTableComponent extends Component {
  render = () => {
    if (!this.props.rows) {
      return null;
    }
    return (      
      <TableContainer component={Paper} style={{ maxHeight: '30em' }}>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              {columns.map((col) => (
                <TableCell
                  key={col.field}
                  style={{
                    fontWeight: 'bold',
                    backgroundColor: '#1976d2',
                    color: '#fff'
                  }}
                >
                  {col.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {this.props.rows.map((row, idx) => (
              <TableRow key={row.jobId || idx}>
                {columns.map((col) => (
                  <TableCell key={col.field}>
                    {row[col.field]}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };
}

const mapStateToPropsSelector = createStructuredSelector({});

export const DIJobsTable = connect(mapStateToPropsSelector)(
  DIJobTableComponent
);
